import z from "zod";

/**
 * RegistroAtendimentoSchema
 */

export const RegistroAtendimentoSchema = z.object({
  tipo: z.coerce.number().default(0),
  descricao: z.string().nonempty('Este campo deve ser preenchido!'),
  dataInicio: z.coerce.date().nullable().default(null),
  dataTermino: z.coerce.date().nullable().default(null),
  observacoes: z.string().nullable().default(null),
  responsavelConstrutora: z.coerce.number().nullable().default(null),
  responsavelCliente: z.string().nullable().default(null),
});

/**
 * RegistroAtendimentoForm
 */

export type RegistroAtendimentoForm = z.infer<typeof RegistroAtendimentoSchema>;